import { useEffect } from 'react'
import * as amplitude from '@amplitude/unified'
import { AmplitudeRequiredCookieConsentGroup } from '../../GlobalVariables/Amplitude'
import { AmplitudeInitProps } from '../../types/Scripts'
import { getActiveOneTrustGroups } from '../../utils/onetrust-utils'
import { registerAmplitudeEnrichmentPlugin, setAmplitudeTrafficContext } from '../../utils/amplitude-utils'

let hasInitialized = false

const AmplitudeInit = ({ apiKey, nonce, isOfficeTraffic = false, isBotTraffic = false, zutoExperiment }: AmplitudeInitProps) => {
  useEffect(() => {
    if (typeof window === 'undefined' || !apiKey) return

    setAmplitudeTrafficContext({ isOfficeTraffic, isBotTraffic, zutoExperiment })

    const initIfConsented = (): void => {
      if (hasInitialized) return
      if (!getActiveOneTrustGroups().includes(AmplitudeRequiredCookieConsentGroup)) return
      hasInitialized = true
      amplitude
        .initAll(apiKey, {
          serverZone: 'EU',
          analytics: { autocapture: true },
          sessionReplay: { sampleRate: 1 },
          engagement: { nonce },
          experiment: {}
        })
        .then(() => {
          amplitude.experiment()?.start()
          registerAmplitudeEnrichmentPlugin()
        })
    }

    initIfConsented()
    window.addEventListener('OneTrustGroupsUpdated', initIfConsented)
    ;(
      window as { OneTrust?: { OnConsentChanged?(cb: () => void): void } }
    ).OneTrust?.OnConsentChanged?.(initIfConsented)

    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', initIfConsented)
    }
  }, [apiKey, isOfficeTraffic, isBotTraffic, zutoExperiment])

  return null
}

export default AmplitudeInit
